import commonService from './commonService'

const getAll = async (signal = null) => {
  return await commonService.getAll('communes', signal)
}

const getAllByTerritory = async (territoryId, signal = null) => {
  return await commonService.getAllBy('zones', territoryId, 'communes', signal)
}

const get = async (id) => {
  return await commonService.get('communes', id)
}

export default { getAll, getAllByTerritory, get }
